import { FC } from 'react';
import { StoryType } from '@edikk-edikk/country-frontend';
import {
  StoryDetailContext,
  StoryDetailContextType,
  StoryDetailHeader,
  StoryDetailPhoto,
} from '#advertStory/detail';
import storyDetailCss from '../assets/detail/story-detail.module.scss';

type PropsType = {
  story: StoryType;
};

const StoryDetail: FC<PropsType> = ({
  story,
}) => {
  const storyDetailContextValue: StoryDetailContextType = {
    story,
  };

  return (
    <StoryDetailContext value={storyDetailContextValue}>
      <div className={storyDetailCss.storyDetail}>
        <StoryDetailPhoto />
        <StoryDetailHeader />
      </div>
    </StoryDetailContext>
  );
};

export { StoryDetail };
